import store from '@/store'

export default [
  {
    path: '/users',
    name: 'users',
    component: () =>
      import(/* webpackChunkName: "users" */ '@/modules/users/_views/Index'),
    redirect: { name: 'active_users' },
    children: [
      {
        name: 'active_users',
        path: 'active',
        meta: {
          section: 'users',
          allowedRoles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_ADMIN_OWNER', 'ROLE_ACCOUNT_HOLDER', 'ROLE_REGULAR']
        },
        component: () =>
          import(
            /* webpackChunkName: 'active-users' */ '@/modules/users/_views/active/OfficeUsersList'
          )
      }
    ],
    beforeEnter: (to, from, next) => {
      if (store.getters['LoginStore/isUser']) {
        if (store.getters['CompanyStore/hasOfficeOwnerInviteFeature']) {
          next()
        } else {
          next({ name: 'dashboard' })
        }
      } else {
        next()
      }
    }
  },
  {
    path: '/users/detail/:id',
    name: 'user_detail',
    component: () =>
      import(
        /* webpackChunkName: 'user-detail' */ '@/modules/users/_views/detail/UserDetailIndex'
      ),
    redirect: to => ({
      name: 'user_cards'
    }),
    children: [
      {
        name: 'user_overview',
        path: '/users/detail/:id/overview',
        meta: {
          section: 'users',
          breadcrumb: 'user',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_COMMERCIAL',
            'ROLE_ADMIN',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER'

          ]
        },
        component: () =>
          import(
            /* webpackChunkName: 'user-overview' */ '@/modules/users/_views/detail/UserOverviewIndex'
          )
      },
      {
        name: 'user_cards',
        path: '/users/detail/:id/cards',
        meta: {
          section: 'users',
          breadcrumb: 'user',
          allowedRoles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_ADMIN_OWNER', 'ROLE_ACCOUNT_HOLDER']
        },
        component: () =>
          import(
            /* webpackChunkName: 'user-cards' */ '@/modules/users/_views/detail/UserCardsIndex'
          )
      },
      {
        name: 'user_transactions',
        path: '/users/detail/:id/transactions',
        meta: {
          section: 'users',
          breadcrumb: 'user',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_COMMERCIAL',
            'ROLE_ADMIN',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER'

          ]
        },
        component: () =>
          import(
            /* webpackChunkName: 'user-transactions' */ '@/modules/users/_views/detail/UserTransactionsIndex'
          )
      },
      {
        name: 'user_budgets',
        path: '/users/detail/:id/budgets',
        meta: {
          section: 'users',
          breadcrumb: 'user',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER'

          ]
        },
        component: () =>
          import(
            /* webpackChunkName: 'user-budgets' */ '@/modules/users/_views/detail/UserBudgetsIndex'
          )
      },
      {
        name: 'user_benefits',
        path: '/users/detail/:id/benefits',
        meta: {
          section: 'users',
          breadcrumb: 'user',
          allowedRoles: ['ROLE_ADMIN_OWNER', 'ROLE_ADMIN', 'ROLE_ACCOUNT_HOLDER', 'ROLE_REGULAR']
        },
        component: () =>
          import(
            /* webpackChunkName: 'user-cards' */ '@/modules/users/_views/detail/UserBenefitsIndex'
          )
      },
      {
        name: 'user_reimbursements',
        path: '/users/detail/:id/reimbursements',
        meta: {
          section: 'users',
          breadcrumb: 'user',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER'

          ]
        },
        component: () =>
          import(
            /* webpackChunkName: 'user-cards' */ '@/modules/users/_views/detail/UserReimbursementsIndex'
          )
      }
    ]
  },
  {
    path: '/accept-invitation/:token',
    name: 'accept-invitation',
    component: () =>
      import(
        /* webpackChunkName: "accept-invitation" */ '@/modules/users/_views/signup/UserAcceptInvitation'
      ),
    meta: {
      layout: 'blank',
      isPublic: true
    }
  },
  {
    name: 'profile',
    path: '/profile',
    component: () =>
      import(
        /* webpackChunkName: 'user-profile' */ '@/modules/users/_views/profile/UserProfileIndex'
      ),
    redirect: { name: 'user_profile_detail' },
    children: [
      {
        name: 'user_profile_detail',
        path: 'details',
        component: () =>
          import(
            /* webpackChunkName: 'user-detail' */ '@/modules/users/_views/profile/UserProfileDetailIndex'
          ),
        meta: {
          section: 'profile',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN_OWNER',
            'ROLE_ACCOUNT_HOLDER',
            'ROLE_ADMIN',
            'ROLE_REGULAR',
            'ROLE_BOOKKEEPER',
            'ROLE_COMMERCIAL',
            'ROLE_SUPER_BOOKKEEPER'
          ]
        }
      },
      {
        name: 'user_preferences',
        path: 'preferences',
        meta: {
          section: 'profile',
          allowedRoles: [
            'ROLE_SUPER_ADMIN',
            'ROLE_ADMIN',
            'ROLE_REGULAR',
            'ROLE_BOOKKEEPER'
          ]
        },
        component: () =>
          import(
            /* webpackChunkName: 'user-preferences' */ '@/modules/users/_views/profile/UserProfilePreferencesIndex'
          )
      }
    ]
  }
]
